import React, { useEffect } from "react";
import { Col, Row, Select } from "antd";
import { connect } from "react-redux";
import { getSummaryDimensions, getSummaryKpiSelected, getTableLoading } from "../../../selectors";
import { changeSummaryDimensions } from "../../../actions/stats";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useState } from "react";
import { dimensionsByKpi } from "../../../summary/dimensions";
import { selectUserRoleId } from "../../../../../redux/selectors/user";
import { roles } from "../../../../../configs/constants";

const { Option } = Select;

const DimensionsSelect = props => {
  const allDimensions = dimensionsByKpi(props.summaryKpi);
  const getOptions = selectedDimensions => {
    const options = [];
    for (let i = 0; i < allDimensions.length - 1; i++) {
      const { id, label } = allDimensions[i];
      if (selectedDimensions.indexOf(id) === -1) {
        options.push(
          <Option key={i} value={id}>
            {label}
          </Option>
        );
      }
    }
    if (props.order === 0 && props.addGlobalDim) {
      //add global
      options.unshift(
        <Option key={"global"} value={"global"}>
          {"Global"}
        </Option>
      );
    }
    return options;
  };
  let value = allDimensions.find(v => v.id === props.dimensions[props.order]);
  value = value && value.label;

  return (
    <Select
      size="default"
      mode="default"
      style={{ width: "100%" }}
      value={value}
      allowClear={props.order > 0 && !props.dimensions[props.order + 1]}
      placeholder={`Dimension ${props.order + 1}`}
      disabled={props.loading || props.order > props.dimensions.length}
      onChange={data => {
        if (data) {
          props.dimensions[props.order] = data;
        } else {
          props.dimensions.splice(props.order, 1);
        }

        //reset all dimensions, keep only global
        if (data === "global") {
          props.changeSummaryDimensions(["global"]);
        } else {
          props.changeSummaryDimensions(props.dimensions);
        }
      }}
    >
      {getOptions(props.dimensions)}
    </Select>
  );
};

const Dimensions = props => {
  //const filteredOptions = getOptions().filter(o => !getOptions().includes(o));
  let displayMaxOrder = props.hasOwnProperty("displayMaxOrder") ? props.displayMaxOrder : 3;
  const dimensions = Array.isArray(props.dimensions) ? props.dimensions : [];

  const [items, setItems] = useState(
    Array.from({ length: 4 }, (v, k) => k).map(k => ({
      id: `dimension-${k}`,
      order: k,
      content: dimensions[k]
    }))
  );
  useEffect(() => {
    setItems(
      Array.from({ length: 4 }, (v, k) => k).map(k => ({
        id: `dimension-${k}`,
        order: k,
        content: dimensions[k]
      }))
    );
  }, [dimensions]);

  const reorder = (list, startIndex, endIndex) => {
    if (!list[endIndex].content) return null;

    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    const dimensions = result.map(item => item.content).filter(item => item);

    props.changeSummaryDimensions(dimensions);
    return result;
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",

    // change background colour if dragging
    background: "white", // isDragging ? "#E46902" : "white",
    paddingLeft: 5,
    paddingRight: 5,
    flex: 1,
    // styles we need to apply on draggables
    ...draggableStyle
  });
  const getListStyle = isDraggingOver => ({
    // background: isDraggingOver ? "lightblue" : "white",
    display: "flex",
    overflow: "auto"
  });
  const onDragEnd = result => {
    // dropped outside the list

    if (!result.destination) {
      return;
    }

    const itemsReordered = reorder(items, result.source.index, result.destination.index);
    if (itemsReordered) setItems(itemsReordered);
  };
  const col = 24 / (displayMaxOrder + 1);
  if (displayMaxOrder === 3) {
    return (
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable" direction="horizontal">
          {(provided, snapshot) => (
            <div ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)} {...provided.droppableProps}>
              {items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index} isDragDisabled={!item["content"]}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                    >
                      {displayMaxOrder >= item["order"] && (
                        <DimensionsSelect order={item["order"]} addGlobalDim={!props.isTerrain} {...props} />
                      )}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }

  return (
    <Row gutter={16}>
      <Col span={col}>
        {displayMaxOrder >= 0 && <DimensionsSelect order={0} addGlobalDim={!props.isTerrain} {...props} />}
      </Col>
      <Col span={col}>{displayMaxOrder >= 1 && <DimensionsSelect order={1} {...props} />}</Col>
      <Col span={col}>{displayMaxOrder >= 2 && <DimensionsSelect order={2} {...props} />}</Col>
      <Col span={col}>{displayMaxOrder >= 3 && <DimensionsSelect order={3} {...props} />}</Col>
    </Row>
  );
};

//REDUX
const mapStateToProps = state => {
  const dimensions = getSummaryDimensions(state);
  const summaryKpi = getSummaryKpiSelected(state);
  const loading = getTableLoading(state);
  const userRoleId = selectUserRoleId(state);
  const isTerrain = userRoleId === roles.TERRAIN;
  return { dimensions, summaryKpi, loading, isTerrain };
};

export default connect(mapStateToProps, { changeSummaryDimensions })(Dimensions);



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/filters/Dimensions.js